"use strict";

export default {
  setResellerOrder(state, payload) {
    state.resellerOrders = payload;
  },
};
